module.exports = __webpack_public_path__ + "static/media/buyed.65a69487.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/buyed.png
// module id = 1222
// module chunks = 0